import { render } from "./InvoiceSettingCreate.vue?vue&type=template&id=cab6f3e4"
import script from "./InvoiceSettingCreate.vue?vue&type=script&lang=js"
export * from "./InvoiceSettingCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__